import { CheckOutlined, CopyOutlined } from "@ant-design/icons";
import { Typography } from "antd";
import cn from "classnames";
import { CSSProperties, FC } from "react";

import { useLoc } from "@app/shared/lib/hooks";

import styles from "./Copyable.module.scss";

type Props = {
  text?: string;
  onCopy?: () => void;
  className?: string;
  style?: CSSProperties;
};

export const Copyable: FC<Props> = ({ text, onCopy, className, style }) => {
  const loc = useLoc();

  return (
    <Typography.Paragraph
      className={cn(className, styles.copyable)}
      style={style}
      copyable={{
        icon: [
          <CopyOutlined key="copy-icon" />,
          <CheckOutlined key="copied-icon" />,
        ],
        tooltips: [
          loc.word("Form.copyMsg", { default: "Copy" }),
          loc.word("Form.copiedMsg", { default: "Copied" }),
        ],
        text,
        onCopy,
      }}
    />
  );
};
